export const KINFEED_POST_MAX_LENGTH = 63_206;
export const KINFEED_POST_PREVIEW_CHARACTER_LIMIT = 500;

export const isKinfeedPostWithinLimit = (content: string) =>
  content.length <= KINFEED_POST_MAX_LENGTH;

export const shouldCollapseKinfeedPost = (content: string) =>
  content.length > KINFEED_POST_PREVIEW_CHARACTER_LIMIT;
